import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {VehicleTransaction} from '../../../models/vte';
import {resolveOperationalAttentionBadge} from '../../../services/vte/vte.constants';

@Component({
    selector: 'app-operational-attention-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span *ngIf="badge as resolved" class="operational-attention-badge" [title]="resolved.hint">
            {{ resolved.label }}
        </span>
    `,
    styles: [`
        .operational-attention-badge {
            display: inline-flex;
            align-items: center;
            padding: 0.2rem 0.55rem;
            border-radius: 999px;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            line-height: 1.2;
            white-space: nowrap;
            background: #FFEDD5;
            color: #C2410C;
        }
    `],
})
export class OperationalAttentionBadgeComponent {
    @Input({required: true}) transaction!: VehicleTransaction;

    get badge(): { label: string; hint: string } | null {
        return resolveOperationalAttentionBadge(this.transaction);
    }
}
